import { URL } from 'react-native-url-polyfill';

export function mobileLinkDestination(value) {
  if (typeof value !== 'string' || value.length > 2048 || value.startsWith('//')) return null;
  try {
    const url = new URL(value, 'https://gab.ai');
    if (url.username || url.password || url.port || url.hash) return null;
    const native = url.protocol === 'gabai:';
    if (!native && (url.protocol !== 'https:' || url.hostname !== 'gab.ai')) return null;
    const path = native ? `/${url.hostname}${url.pathname === '/' ? '' : url.pathname}` : url.pathname;
    if (/^\/(c|g)\/[A-Za-z0-9_-]+$/.test(path)
      || /^\/agents(?:\/(?:category\/)?[A-Za-z0-9_-]+)?$/.test(path)
      || ['/referral', '/remote-projects'].includes(path)
      || !url.search && ['/launch/chat', '/launch/voice', '/launch/work'].includes(path)) return path;
  } catch {}
  return null;
}

export function createNativeLinkInbox(now = Date.now) {
  let pending = null, received = false;
  const listeners = new Set();
  return {
    capture(path) {
      const destination = mobileLinkDestination(path);
      if (!destination) return null;
      pending = { path: destination, at: now() }; received = true;
      listeners.forEach(listener => listener());
      return destination;
    },
    snapshot: () => pending,
    wasReceived: () => received,
    take() {
      const result = pending; pending = null;
      listeners.forEach(listener => listener());
      return result && now() - result.at < 10 * 60 * 1000 ? result.path : null;
    },
    subscribe(listener) { listeners.add(listener); return () => listeners.delete(listener); },
  };
}

// Only allowlisted paths are retained in memory through sign-in. Pairing
// secrets are held by remotePairingInbox; no incoming query enters this inbox.
export const nativeLinkInbox = createNativeLinkInbox();
